/**
 * Общие стилевые helpers для DiscrepancyCard / DiscrepancyMatrixCard
 * (фича 024 — Phase 5a refactor).
 *
 * Severity-rail и outer-классы карточки идентичны для обоих вариантов
 * (aggregated и matrix). До Phase 5a логика была продублирована.
 */

export function cardClassName(severity: "error" | "warning", highlighted: boolean): string {
	// Sprint 6 / C5.4: transition по `outline-color` (не по `outline` shorthand) —
	// плавный fade-in/out цвета без скачка ширины. Amber-300 — мягкая подсветка
	// для drill-down highlight (раньше blue-500: слишком агрессивно).
	const base =
		"rounded-lg border border-slate-200 bg-white overflow-hidden outline outline-2 outline-offset-2 transition-[outline-color] duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500";
	const highlightClasses = highlighted ? "outline-amber-300" : "outline-transparent";
	return `${base} ${highlightClasses}`;
}

export function railColor(severity: "error" | "warning"): string {
	return severity === "error" ? "bg-red-500" : "bg-yellow-500";
}
